import {capableBrowser} from './github/capable-browser'

if (!capableBrowser()) {
  const banner = document.getElementById('unsupported-browser')
  if (banner) {
    banner.removeAttribute('hidden')
  }
}
